import { Navigate } from "react-router-dom";
import useStoreAdminAuth from "../hooks/useStoreAdminAuth";

export default function StoreAdminRoute({ children }) {
  const { loading, loggedIn } = useStoreAdminAuth();

  if (loading) {
    return (
      <div className="admin-scope dark flex min-h-screen items-center justify-center bg-background text-foreground">
        <p className="text-sm text-muted-foreground">로그인 상태 확인 중…</p>
      </div>
    );
  }
  if (!loggedIn) return <Navigate to="/store-admin/login" replace />;

  return children;
}
